import { render, staticRenderFns } from "./ForumResponseProfile.vue?vue&type=template&id=1ff50268&scoped=true"
import script from "./ForumResponseProfile.vue?vue&type=script&lang=js"
export * from "./ForumResponseProfile.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseProfile.vue?vue&type=style&index=0&id=1ff50268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff50268",
  null
  
)

export default component.exports